// extracted by mini-css-extract-plugin
export default {"educationContainer":"Education_educationContainer__4IXAd","heading":"Education_heading__6s4w3","education":"Education_education__+Qhpv","line":"Education_line__piA6F"};